import React from 'react'
import Permissions from 'components/permissions'
import { AccessResourceKinds, UserRoles } from 'app-constants'
import { useDataContext } from 'components/spreadsheet/contexts/data/useDataContext'
import Modal, { ModalProps } from 'components/modal'

const PermissionsModal: React.FC<ModalProps> = ({ id, open, setOpen, onClose }) => {
  const { spreadsheetData } = useDataContext()
  if (!spreadsheetData.loading) {
    return (
      <Modal id={id} open={open} setOpen={setOpen} onClose={onClose} title={'Permissions'}>
        <div className="overflow-x-hidden p-2.5 m-2.5 list-none">
          <div>
            <div className="border-b border-divider font-bold text-base pt-2.5 pb-2.5">Table Permissions</div>
            <Permissions
              resource={AccessResourceKinds.TABLE}
              resourceId={spreadsheetData.tableDetails.publicId}
              excludedPermissionCategories={[UserRoles.VIEWER, UserRoles.CONTRIBUTOR]}
            />
          </div>
          <div>
            <div className="border-b border-divider font-bold text-base pt-2.5 pb-2.5">View Permissions</div>
            <Permissions
              resource={AccessResourceKinds.VIEW}
              resourceId={spreadsheetData.viewDetails.publicId}
              excludedPermissionCategories={[UserRoles.OWNER]}
            />
          </div>
        </div>
      </Modal>
    )
  } else {
    return <div />
  }
}

export default PermissionsModal
